export default "__VITE_ASSET__CuavQ0Ot__";